import "98.css";
import React, { useState, useEffect } from 'react'

export default function ContactTest() {

    var nameRegex = /\w+/gi
    var emailRegex = /.+@.+\..+/gi

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        //console.log(selector)
        //console.log(selector.nodeName)

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        //Toolbar tab buttons
        if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
            dataName = selector.getAttribute('data-name');
            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            selector = selector.closest('.window');
            dataName = selector.getAttribute('data-name');
        }

        if (!document.querySelector('.window[data-name="' + dataName +'"]').classList.contains('active')) {
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        }
    }

    // function moveToTop(selector) {

    //     var selector = selector.target.closest('.window');
    //     //console.log(selector);
    //     var dataName = selector.getAttribute('data-name');

    //     if (Array.from(document.querySelector('.window[data-name="Explorer"]').parentElement.children).indexOf(document.querySelector('.window[data-name="' + dataName + '"]')) !== document.querySelector('.window[data-name="Explorer"]').parentElement.children.length - 1) {
    //         document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));
    //     }
    // }
    
    function hideContactForm(e) {
        var el = e.target
        //console.log(el);
        var dataName = el.getAttribute('data-name')
        checkTray(el, true);
        document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden')
        setName('')
        setEmail('')
        setMessage('')
        document.querySelectorAll('.window[data-name="Contact Form"] .error-field').forEach(errorField => {
            errorField.classList.add('hidden')
        })
        setSubmitted(false)
    }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    function checkName() {
        if (!document.querySelector('input#name').value.match(nameRegex)) {
        document.querySelector('input#name').closest('.field-row-stacked').nextElementSibling.classList.remove('hidden');
        } else {
        document.querySelector('input#name').closest('.field-row-stacked').nextElementSibling.classList.add('hidden');
        }
        toggleSubmitDisabled();
    }

    function checkEmail() {
        //console.log('check email')
        toggleSubmitDisabled();
        document.querySelector('input#eml').removeEventListener('blur', checkEmail)
        if (!document.querySelector('input#eml').value.match(emailRegex)) {
            document.querySelector('input#eml').closest('.field-row-stacked').nextElementSibling.classList.remove('hidden');
        } else if (document.querySelector('input#eml').value.match(emailRegex)) {
            document.querySelector('input#eml').closest('.field-row-stacked').nextElementSibling.classList.add('hidden');
        }
        if (!document.querySelector('input#eml').classList.contains('listening')) {
            document.querySelector('input#eml').classList.add('listening');
            document.querySelector('input#eml').addEventListener('input', function(e) {
                //console.log('checking email input')
                if (!document.querySelector('input#eml').value.match(emailRegex)) {
                document.querySelector('input#eml').closest('.field-row-stacked').nextElementSibling.classList.remove('hidden');
                } else if (document.querySelector('input#eml').value.match(emailRegex)) {
                document.querySelector('input#eml').closest('.field-row-stacked').nextElementSibling.classList.add('hidden');
                }
                toggleSubmitDisabled();
            });
        }
    }

    function checkMsg() {
        if (document.querySelector('textarea#msg').value === '') {
        document.querySelector('textarea#msg').closest('.field-row-stacked').nextElementSibling.classList.remove('hidden');
        } else {
        document.querySelector('textarea#msg').closest('.field-row-stacked').nextElementSibling.classList.add('hidden');
        }
        toggleSubmitDisabled();
    }

    function toggleSubmitDisabled() {
        if (document.querySelector('input#name').value.match(nameRegex) && document.querySelector('input#eml').value.match(emailRegex) && document.querySelector('textarea#msg').value !== '') {
            //console.log('ENABLE THE BUTTON');
            //document.querySelector('input.form-submit').disabled = false;
            document.querySelector('button.form-submit').disabled = false; 
        } else if (!document.querySelector('button.form-submit').disabled) {
            //document.querySelector('input.form-submit').disabled = true;
            document.querySelector('button.form-submit').disabled = true; 
        }
    }
    
    const [isSubmitted, setSubmitted] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState(""); 
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        // create a new XMLHttpRequest
        var xhr = new XMLHttpRequest();

        // get a callback when the server responds
        xhr.addEventListener('load', () => {
            // update the response state and the step
            //console.log(xhr.responseText);
            document.querySelector('#contact-form')
            setSubmitted(true)
        });

        // open the request with the verb and the url
        xhr.open('GET', 'http://belucky.band/contactForm/contactform2.php?sendto=' + email + 
                                '&name=' + name + 
                                '&message=' + message);

        // send the request
        xhr.send();
        
    };

    // return (
    //     <>

    //     <div className="window hidden" data-name="Contact Form" onClick={reOpen}>

    //         <div className="title-bar">
    //             <div className="title-bar-text">Message</div>
    //             <div className="title-bar-controls">
    //                 <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Contact Form"></button>
    //                 <button className="form-close" aria-label="Close" onClick={hideContactForm} data-name="Contact Form"></button>
    //             </div>
    //         </div>

    //         <div className="window-body">
    //             <form id="contact-form" action="contactform2.php" method="POST" onSubmit={(event) => handleSubmit(event)}>
    //                 <div className="field-row-stacked" style={{width: "200px"}}>
    //                     <label htmlFor="name">Name</label>
    //                     <input id="name" type="text" name="fullName" placeholder="Name*" autoComplete="on" value={name} onChange={(e) => setName(e.target.value)} onInput={checkName}/>
    //                 </div>
    //                 <div className='contact-form form-field error-field hidden'>
    //                     <span>Please enter your name so we know who you are!</span>
    //                 </div>
    //                 <div className="field-row-stacked" style={{width: "200px"}}>
    //                     <label htmlFor="eml">Email</label>
    //                     <input id="eml" type="text" placeholder="Email*" autoComplete="on" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={checkEmail}/>
    //                 </div>
    //                 <div className='contact-form form-field error-field hidden'>
    //                     <span>Please enter a valid email address.</span>
    //                 </div>
    //                 <div className="field-row-stacked">
    //                     <label htmlFor="msg">Message</label>
    //                     <textarea id="msg" rows="8" placeholder="Write your message here..." value={message} onChange={(e) => setMessage(e.target.value)} onInput={checkMsg}></textarea>
    //                 </div>
    //                 <div className='contact-form form-field error-field hidden'>
    //                     <span>Please enter a message!</span>
    //                 </div>

    //                 {/* <input className="form-submit spacing_top--med" type="submit" value="Send" disabled></input> */}
    //                 <button className="form-submit spacing_top--med" type="submit" value="Send" disabled>Send</button>
    //             </form>
    //         </div>

    //     </div>

    //     </> 
    // )

    return isSubmitted ? (
        <div className="window hidden" data-name="Contact Form" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">Message</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Contact Form"></button>
                    <button className="form-close" aria-label="Close" onClick={hideContactForm} data-name="Contact Form"></button>
                </div>
            </div>

            <div className="window-body">
                <div className="success-msg">
                    Thanks for your message, we'll get back to you as soon as possible.
                    <br></br>
                    <br></br>
                    You can also reach out to us on socials.
                </div>
                <a href="https://www.instagram.com/beluckyband/" target="_blank" rel="noreferrer" className="button" >DM on Instagram</a>
            </div>

        </div>
    ) : (
        <>

        <div className="window hidden" data-name="Contact Form" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">Message</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Contact Form"></button>
                    <button className="form-close" aria-label="Close" onClick={hideContactForm} data-name="Contact Form"></button>
                </div>
            </div>

            <div className="window-body">
                <form id="contact-form" action="contactform2.php" method="POST" onSubmit={(event) => handleSubmit(event)}>
                    <div className="field-row-stacked" style={{width: "200px"}}>
                        <label htmlFor="name">Name</label>
                        <input id="name" type="text" name="fullName" placeholder="Name*" autoComplete="on" value={name} onChange={(e) => setName(e.target.value)} onInput={checkName}/>
                    </div>
                    <div className='contact-form form-field error-field hidden'>
                        <span>Please enter your name so we know who you are!</span>
                    </div>
                    <div className="field-row-stacked" style={{width: "200px"}}>
                        <label htmlFor="eml">Email</label>
                        <input id="eml" type="text" placeholder="Email*" autoComplete="on" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={checkEmail}/>
                    </div>
                    <div className='contact-form form-field error-field hidden'>
                        <span>Please enter a valid email address.</span>
                    </div>
                    <div className="field-row-stacked">
                        <label htmlFor="msg">Message</label>
                        <textarea id="msg" rows="8" placeholder="Write your message here..." value={message} onChange={(e) => setMessage(e.target.value)} onInput={checkMsg}></textarea>
                    </div>
                    <div className='contact-form form-field error-field hidden'>
                        <span>Please enter a message!</span>
                    </div>

                    {/* <input className="form-submit spacing_top--med" type="submit" value="Send" disabled></input> */}
                    <button className="form-submit spacing_top--med" type="submit" value="Send" disabled>Send</button>
                </form>
            </div>

        </div>

        </> 
    )
}